import { render, staticRenderFns } from "./RightNews.vue?vue&type=template&id=31cf93c8&scoped=true"
import script from "./RightNews.vue?vue&type=script&lang=js"
export * from "./RightNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf93c8",
  null
  
)

export default component.exports